import React from 'react';

import { FieldSet } from 'app/component/fieldset/FieldSet';
import { IntroductionFormStore } from 'app/logic/pages/introduction/IntroductionFormStore';
import { PhoneFormItem } from 'app/logic/pages/introduction/PhoneFormItem';
import { Section } from 'app/component/Section';

export interface PersonalDataFormProps {
    formStore: IntroductionFormStore;
}

export const PersonalDataForm = ({ formStore }: PersonalDataFormProps) => {
    return (
        <Section
            className={'personalDataFormSection'}
            content={
                <FieldSet
                    className={'personalDataForm'}
                    fieldsProps={[
                        // https://projects.alfabank.by/browse/CC2C-990
                        // {
                        //     className: 'id',
                        //     title: '',
                        //     value:
                        //         <IdentityNumberFormItem formStore={formStore}/>
                        // },
                        {
                            className: 'phone',
                            title: '',
                            value: <PhoneFormItem formStore={formStore} />,
                        },
                    ]}
                />
            }
        />
    );
};
